import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'store/types'

const stateAddress = (state: RootState) => state.address
const stateYandexMap = (state: RootState) => state.yandexMap

export const selectAddress = createSelector(stateAddress, address => address)

export const yandexMap = createSelector(stateYandexMap, map => map)

export const yandexMapRouteSetting = createSelector(
  stateYandexMap,
  map => map.routeSetting,
)
